import { render, staticRenderFns } from "./ContactErft.vue?vue&type=template&id=61b2190a&scoped=true&"
import script from "./ContactErft.vue?vue&type=script&lang=js&"
export * from "./ContactErft.vue?vue&type=script&lang=js&"
import style0 from "./ContactErft.vue?vue&type=style&index=0&id=61b2190a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b2190a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VImg,VSheet})
